import {Button, Typography} from "@material-ui/core";
import React, {useContext, useEffect, useState} from "react";
import {AppContext} from "../AppContext";
import {useHistory} from "react-router-dom";
import {MessageContext} from "../MessageContext";
import confappdata from "confappdata"

export default function Home() {
    const context = useContext(AppContext)
    const history = useHistory();
    const [homeInfo, setHomeInfo] = useState(null)
    const messageContext = useContext(MessageContext)
    const [regCount, setRegCount] = useState(0)

    const [errorMessage, setErrorMessage] = useState("")
    const [videoTracts, setVideoTracts] = useState(null)

    const constraints = window.constraints = {
        audio: false,
        video: true
    };

    async function init(e) {
        try {
            const stream = await navigator.mediaDevices.getUserMedia(constraints);
            handleSuccess(stream);
            // e.target.disabled = true;
        } catch (e) {
            handleError(e);
        }
    }

    function handleSuccess(stream) {
        setErrorMessage("")

        // const video = document.querySelector('video');
        let videoTracks = stream.getVideoTracks();
        setVideoTracts(stream)
        console.log('Got stream with constraints:', constraints);
        console.log(`Using video device: ${videoTracks[0].label}`);
        // window.stream = stream; // make variable available to browser console
        document.getElementById("gum-local").srcObject = stream;

        connect(stream)
    }

    function handleError(error) {
        if (error.name === 'ConstraintNotSatisfiedError') {
            const v = constraints.video;
            setErrorMessage(`The resolution ${v.width.exact}x${v.height.exact} px is not supported by your device.`);
        } else if (error.name === 'PermissionDeniedError') {
            setErrorMessage('Permissions have not been granted to use your camera and ' +
                'microphone, you need to allow the page access to your devices in ' +
                'order for the demo to work.');
        }
        setErrorMessage(`getUserMedia error: ${error.name}`, error);
    }

    const [millicastUrl, setMillicastUrl] = useState("")
    const [millicastJwt, setMillicastJwt] = useState("")

    const PUBLISH_TOKEN = "bf2830cfe21bc81f59d1f9ee8613b30c77893d5f1faf0da85e61c0df8a2d2bee";
    const streamName = 'khpi658t'; //Replace with your stream name.

    useEffect(() => {

        // let url; //Websocket URL path.
        // let jwt; //Authenticated API token.
        // let iceServers; // STUN/TURN server paths to better guarantee our connection.

//Authenticate publisher and get connection point.
        let xhr = new XMLHttpRequest();
        xhr.open("POST", "https://director.millicast.com/api/director/publish", true);
        xhr.setRequestHeader("Authorization", `Bearer ${PUBLISH_TOKEN}`);
        xhr.setRequestHeader("Content-Type", "application/json");
        xhr.onreadystatechange = function () {
            if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
                let js = JSON.parse(xhr.responseText);
                console.log("success:", js);
                setMillicastUrl(js.data.urls[0])
                setMillicastJwt(js.data.jwt)

                // connect();
            }
        }
        xhr.send(JSON.stringify({streamName: streamName}));
    }, [])


// Create a peer connection to Millicast with WebRTC
    function connect(stream) {
        console.log('connecting');
        //create Peer connection object, add TURN servers for fallback.
        let conf = {
            iceServers: [],
            rtcpMuxPolicy: "require",
            bundlePolicy: "max-bundle"
        };
        let pc = new RTCPeerConnection(conf);
        //add media to connection
        stream.getTracks()
            .forEach(track => {
                console.log('track: ', track);
                pc.addTrack(track, stream)
            });
        //connect with Websockets for handshake to media server.
        let ws = new WebSocket(millicastUrl + "?token=" + millicastJwt);
        ws.onopen = function () {
            //create a WebRTC offer to send to the media server
            let offer = pc.createOffer({
                offerToReceiveAudio: true,
                offerToReceiveVideo: true
            }).then(desc => {
                console.log('createOffer Success!');
                pc.setLocalDescription(desc)
                    .then(() => {
                        console.log('setLocalDescription Success!');
                        //set required information for media server.
                        let data = {
                            name: streamName,
                            sdp: desc.sdp,
                            codec: 'h264'
                        }

                        //create payload
                        let payload = {
                            type: "cmd",
                            transId: Math.random() * 10000,
                            name: 'publish',
                            data: data
                        }
                        ws.send(JSON.stringify(payload));
                    })
                    .catch(e => {
                        console.log('setLocalDescription failed: ', e);
                    })
            }).catch(e => {
                console.log('createOffer Failed: ', e)
            });
        }

        ws.addEventListener('message', evt => {
            console.log('ws::message', evt);
            let msg = JSON.parse(evt.data);
            switch (msg.type) {
                //Handle counter response coming from the Media Server.
                case "response":
                    let data = msg.data;
                    let answer = new RTCSessionDescription({
                        type: 'answer',
                        sdp: data.sdp + "a=x-google-flag:conference\r\n"
                    });
                    pc.setRemoteDescription(answer)
                        .then(d => {
                            console.log('setRemoteDescription Success! ');
                            console.log('YOU ARE BROADCASTING!');
                        })
                        .catch(e => {
                            console.log('setRemoteDescription failed: ', e);
                        });
                    break;
            }
        })
    }

    /*const makeStuff = () => {
        //Replace this variable with your token
        const PUBLISH_TOKEN = "bf2830cfe21bc81f59d1f9ee8613b30c77893d5f1faf0da85e61c0df8a2d2bee";

        var xhr = new XMLHttpRequest();

        xhr.open("POST", "https://director.millicast.com/api/director/publish", true);
        xhr.setRequestHeader("Authorization", `Bearer ${PUBLISH_TOKEN}`);
        xhr.setRequestHeader("Content-Type", "application/json");

        xhr.onreadystatechange = function() {
            if (this.readyState === XMLHttpRequest.DONE && this.status === 200) {
                var jsonData = JSON.parse(xhr.responseText);
                console.log("Call Complete:",jsonData);
            }
        }

//Replace "streamName" with the valid name you want to broadcast with.
        xhr.send(JSON.stringify({ streamName: "khpi658t" }));
    }*/

    useEffect(() => {
        fetch(`${process.env.REACT_APP_API_CALL}/home_info`, {
            credentials: 'include'
        })
            .then(response => response.json())
            .then(response => setHomeInfo(response))
    }, [regCount])

    const selectCurrentEvent = (event) => {
        context.selectCurrentEvent(event)
        history.push(`/game/${event.id}`)
    }

    const registerEventbriteEvent = (selectedEvent) => {
        fetch(`${process.env.REACT_APP_API_CALL}/eventbright-register`, {
            method: "POST",
            credentials: 'include',
            headers: {
                "Content-Type": "application/json",
                "Accept": "application/json"
            },
            body: JSON.stringify({
                id: selectedEvent.id,
            })
        })
            .then(response => response.json())
            .then(response => {
                if (response.errors) {
                    alert(response.errors)
                } else {
                    messageContext.showSuccessMessage("Event registration successful!")
                    setRegCount(regCount + 1)
                }
            })
    }

    return (
        <div className="home-body">
            {homeInfo ?
                <>
                    <Typography variant="h3">Events you're attending:</Typography>
                    <ul>
                        {
                            homeInfo.future.map(event => {
                                return <li key={event.id}>{event.name} <Button
                                    onClick={() => selectCurrentEvent(event)}>Select</Button></li>
                            })
                        }
                    </ul>
                    <Typography variant="h3">Events you have tickets for:</Typography>
                    <ul>
                        {
                            homeInfo.available.map(event => {
                                return <li key={event.id}>{event.name} <Button
                                    onClick={() => registerEventbriteEvent(event)}>Register</Button></li>
                            })
                        }
                    </ul>
                    <video id="gum-local" autoPlay playsInline/>
                    <Button onClick={(event) => init(event)}>Wire Video</Button>
                </>
                :
                <Typography variant="h3">Loading...</Typography>
            }

            {/*<Pricing/>*/}

        </div>
    )
}
